import React from 'react';
import { GraduationCap, Users, BookOpen } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-16 bg-gradient-to-b from-white to-[#9a6ebd]/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
          <div>
            {/* Titre et icône - Toujours en ligne */}
            <div className="flex items-center gap-4 mb-8">
              <div className="flex-shrink-0 w-16 h-16 bg-[#9a6ebd]/10 rounded-full flex items-center justify-center">
                <Users className="w-8 h-8 text-[#9a6ebd]" />
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-[#323c5f]">
                Qui sommes-nous ?
              </h2>
            </div>

            <div className="bg-white rounded-2xl shadow-lg border-2 border-[#ceace8] p-4 sm:p-8 space-y-4 sm:space-y-6">
              {/* Image mobile - Centrée et plus grande */}
              <div className="lg:hidden flex justify-center mb-6">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2Fphoto%20profil%20SES.jpeg?alt=media&token=b2a39978-10b6-4889-9a79-d50e6220dbf5"
                  alt="Marion et Brandon"
                  className="w-48 h-48 rounded-2xl object-cover shadow-xl"
                />
              </div>

              {/* Sections de texte - Responsive et lisible */}
              <div className="flex flex-col sm:flex-row items-start gap-3 p-4 bg-[#9a6ebd]/5 rounded-xl">
                <GraduationCap className="text-[#9a6ebd] flex-shrink-0 mt-1" size={24} />
                <p className="text-sm sm:text-base text-gray-600">
                  Nous sommes Brandon et Marion, deux passionnés de pédagogie 
                  et créateurs de contenus éducatifs. Après avoir tous les deux obtenu un bac ES 
                  en 2019 (spécialité SES), nous avons poursuivi nos études dans des domaines 
                  complémentaires.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row items-start gap-3 p-4 bg-[#9a6ebd]/5 rounded-xl">
                <BookOpen className="text-[#9a6ebd] flex-shrink-0 mt-1" size={24} />
                <p className="text-sm sm:text-base text-gray-600">
                  Marion a suivi une licence de droit, tandis que Brandon a intégré une classe 
                  préparatoire aux grandes écoles de commerce avant de se spécialiser en sciences 
                  sociales et en sciences de l'éducation.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row items-start gap-3 p-4 bg-[#9a6ebd]/5 rounded-xl">
                <Users className="text-[#9a6ebd] flex-shrink-0 mt-1" size={24} />
                <p className="text-sm sm:text-base text-gray-600">
                  Depuis deux ans, nous mettons notre énergie à transmettre notre passion pour 
                  les sciences économiques et sociales à travers les réseaux sociaux. Avec une 
                  communauté de plus de 57 000 abonnés, nous partageons des cours complets sur YouTube, 
                  des fiches de révision sur Instagram, et des vidéos explicatives sur TikTok.
                </p>
              </div>
            </div>
          </div>

          {/* Image desktop - Optimisée et responsive */}
          <div className="hidden lg:flex lg:items-center lg:justify-center">
            <div className="relative w-full max-w-lg transform hover:scale-105 transition-transform duration-300">
              <div className="absolute inset-0 bg-[#9a6ebd]/10 rounded-2xl transform rotate-3"></div>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/site-comprendre-les-ses-c5b6a.firebasestorage.app/o/images%2Fphoto%20profil%20SES.jpeg?alt=media&token=b2a39978-10b6-4889-9a79-d50e6220dbf5"
                alt="Marion et Brandon"
                className="relative w-full aspect-square object-cover rounded-2xl shadow-xl"
              />
              <div className="absolute inset-0 rounded-2xl shadow-inner"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;